<template>
  <el-container>
    <el-main>
      <el-table :data="colorSelects">
        <el-table-column label="色の系統">
          <template slot-scope="scope">
            <span> {{ colorPatterns[scope.row.patternId].name }} </span>
          </template>
        </el-table-column>
        <el-table-column label="色名" prop="name"></el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button size="mini"
                        icon="el-icon-delete"
                        @click="removeColor(scope.$index)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <el-button type="text" v-on:click="visibleAddColorDialog = true">色の追加</el-button>
    </el-footer>
    <el-dialog title="色指定追加"
                :visible.sync="visibleAddColorDialog"
                width="40%"
                append-to-body>
      <el-row>
        <selector v-model="edit.patternId"
                  v-bind:label="'色の系統'"
                  v-bind:spanTitle="spanTitle"
                  v-bind:spanSetting="spanSetting">
          <el-option v-for="item in colorList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
          </el-option>
        </selector>
      </el-row>
      <el-row>
        <el-col :span="spanTitle">
          <div class="input-title">色名</div>
        </el-col>
        <el-col :span="spanSetting">
          <el-input type="text" v-model="edit.name" v-on:input="edit.name = $event" maxlength="13" show-word-limit></el-input>
        </el-col>
      </el-row>
      <el-row v-if="errMsg !== ''">
        <span style="color: red">
          {{ errMsg }}
        </span>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleAddColorDialog = false">キャンセル</el-button>
        <el-button type="primary" @click="addColor()">追加</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import api from '@/http/api.js'
import Selector from '@/components/Selector.vue'

export default {
  name: 'ColorConfig',
  components: {
    selector: Selector
  },
  props: {
    colorSelects: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      visibleAddColorDialog: false,
      spanTitle: 4,
      spanSetting: 17,
      colorPatterns: {},
      edit: {
        patternId: '',
        name: ''
      },
      colorList: [],
      errMsg: ''
    }
  },
  methods: {
    addColor: function () {
      this.errMsg = ''
      if (this.edit.patternId === '') {
        this.errMsg = '色の系統が指定されていません。'
      }
      if (this.edit.name === '') {
        this.errMsg = this.errMsg + '色名が入力されていません。'
      }
      if (this.errMsg === '') {
        var color = {
          patternId: this.edit.patternId,
          name: this.edit.name
        }
        this.colorSelects.push(color)
        this.edit.patternId = ''
        this.edit.name = ''
        this.$emit('change', this.colorSelects)
        this.visibleAddColorDialog = false
      }
    },
    removeColor: function (index) {
      if (index === 0) {
        this.colorSelects.shift()
      } else if (index === (this.colorSelects.length - 1)) {
        this.colorSelects.pop()
      } else {
        var colorSelectsPre = this.colorSelects.slice(0, index)
        this.colorSelects = colorSelectsPre.concat(this.colorSelects.slice(index + 1, this.colorSelects.length))
      }
      this.$emit('change', this.colorSelects)
    }
  },
  created: async function () {
    this.colorList = await api.color.getColorPatterns()
    this.colorPatterns = {}
    for (const colorPattern of this.colorList) {
      this.colorPatterns[colorPattern.id] = colorPattern
    }
  }
}
</script>

<style scoped>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
}
</style>
